<template>
  <v-app-bar app flat height="64" class="app-topbar">
    <div class="app-topbar__brand">
      <div class="app-topbar__title">HRD</div>
      <div class="app-topbar__subtitle">Human Resource Development</div>
    </div>

    <v-spacer />

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <div class="app-topbar__meta" v-bind="attrs" v-on="on">
          <v-icon small class="app-topbar__meta-icon">mdi-account-badge-outline</v-icon>
          <span class="app-topbar__meta-text">
            {{ userRole || "-" }}: {{ userFacility || "-" }}, {{ userRegion || "-" }}
          </span>
        </div>
      </template>
      <span>{{ userRole || "-" }}: {{ userFacility || "-" }}, {{ userRegion || "-" }}</span>
    </v-tooltip>
  </v-app-bar>
</template>

<script>

import {TrainingCenterService} from '../../components/TrainingCenter/training_center.service';
import {AccreditorService} from '../../components/Accreditors/accreditor.service';

export default {
  name: "DashboardCoreAppBar",

  data: () => ({
    userFacility: null,
    userRole: null,
    userRegion: null,
  }),

  async created() {
    const loggedInUser = JSON.parse(localStorage.getItem("user")).data;

    this.userRole = loggedInUser.userRoles
        ? loggedInUser.userRoles.roleName
        : "-";

    const cpdProviderId = loggedInUser.cpdProviderId ? loggedInUser.cpdProviderId : null;
    const accreditorId = loggedInUser.accreditorId ? loggedInUser.accreditorId : null;
    const eduInstId = loggedInUser.eduInstitutionId ? loggedInUser.eduInstitutionId : null;
    const facilityId = loggedInUser.userFacilityId ? loggedInUser.userFacilityId : null;
    if (cpdProviderId) {
      const cpdRes = await TrainingCenterService.getTrainingCenter(cpdProviderId);
      const cpdProviderName = cpdRes[0]?.trainingCenterName ? cpdRes[0].trainingCenterName : null;
      this.userFacility = cpdProviderName;
    } else if (accreditorId) {
      const accRes = await AccreditorService.getAccreditor(accreditorId);
      const accName = accRes.accreditorName ? accRes.accreditorName : null;
      this.userFacility = accName;
    } else if (eduInstId) {
      this.userFacility = loggedInUser.educationalInstitution?.name;
    } else if (facilityId) {
      this.userFacility = loggedInUser.userFacility?.name;
    } else {
      this.userFacility = '-'
    }

    this.userRegion = loggedInUser.region
        ? loggedInUser.region.name
        : (loggedInUser.expertLevels ? loggedInUser.expertLevels.name : '-');
  },

  computed: {},
};
</script>

<style scoped>
.app-topbar {
  background: rgba(255, 255, 255, 0.86) !important;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(15, 23, 42, 0.08) !important;
}

.app-topbar :deep(.v-toolbar__content) {
  padding: 0 18px;
}

.app-topbar__brand {
  display: grid;
  gap: 2px;
  line-height: 1.1;
}

.app-topbar__title {
  font-size: 0.95rem;
  letter-spacing: 0.06em;
  font-weight: 800;
  color: #0f172a;
  text-transform: uppercase;
}

.app-topbar__subtitle {
  font-size: 0.85rem;
  color: rgba(15, 23, 42, 0.68);
  font-weight: 600;
}

.app-topbar__meta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.10);
  background: rgba(255, 255, 255, 0.65);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
  cursor: default;
}

.app-topbar__meta-icon {
  color: rgba(15, 23, 42, 0.65);
}

.app-topbar__meta-text {
  font-size: 0.9rem;
  color: rgba(15, 23, 42, 0.86);
  font-weight: 600;
  white-space: nowrap;
  max-width: 62vw;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
